<juboo-result [baseUrl]="baseUrl" [selectedCustomer]="customerService.selectedCustomer$ | async"
  [isJubooAgent]="(customerService.isJubooAgent$ | async) ?? false" [isReadOnly]="false"></juboo-result>